import type {Result, UseCase} from 'framework';
import type {AssistantError} from '../../domain/errors';
import type {ConversationDetail} from '../../domain/conversation';
import type {ConversationId} from '../../domain/conversation-id.value-object';
import type {AssistantRepository} from '../ports/assistant.repository';

export class GetConversation implements UseCase<[ConversationId], ConversationDetail> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(id: ConversationId): Promise<Result<ConversationDetail, AssistantError>> {
    return this.repository.getById(id);
  }
}
